import React, { Fragment } from 'react';

import Hero from '../components/home/hero';
import Why from '../components/home/why';
import Why2 from '../components/home/why-2';
import How from '../components/home/how';
import Reviews from '../components/home/reviews';

import Properties from '../components/home/properties';
import About from '../components/home/about';
import OfficeInfo from '../components/home/office-info';
import Contact from '../components/contact';

import bgReview from '../images/pexels-cottonbro-4039184.jpg';

const itemsReview = [
  {
    id: null,
    review: "Mi experiencia en pocas palabras a sido excelente, plena confianza en su trabajo y experiencia en el rubro, coordiales y transparentes en todo, 100% recomendables.",
    author: "Hugo Rojo - Calama"
  },                      
  {
    id: null,
    review: "En un nuevo negocio, como es mi caso, necesitas el mejor apoyo en la orientacion, confianza, como tambien transparencia y Propiedades Galactica ha gestionado de manera excelente todo lo necesario para estar tranquilo, desde encontrar un buen arrendador al seguimiento mes a mes de las condiciones acordadas. Estoy muy feliz y recomiendo los servicios completamente.",
    author: "Oliver García - Temuco"
  },
  {
    id: null,
    review: "Tengo el agrado de recomendar, ampliamente a Galáctica propiedades, quien nos asistió de manera profesional, y eficiente en la gestión de arriendo, desde el primer contacto, demostrando compromiso, conocimiento del mercado, y disposición, para resolver dudas, y acompañar en el proceso, gracias a su gestión, logré concretar la operación, en condiciones favorables, destacó transparencia y atención personalizada, recomiendo todos sus servicios y quienes estén buscando asesoría, recomiendo galácticas propiedades.",
    author: "Anonimo"
  },      
]

export default ()=> {

  return(
    <Fragment>
      <Hero />
      <Why />

 
      <Reviews
        items={itemsReview}
        bgImg={bgReview}
        title="Nuestros clientes hablan de nosotros"
      />
      {/* <Properties /> */}
      {/* <About /> */}
      {/* <OfficeInfo /> */}
      <Contact />
    </Fragment>
  )
}